<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.planInfo}}</div>
    </v-card-title>
    <div v-if="pkg.planNo">
      <!-- <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.selectedPlan}}</v-subheader>
              <div>{{pkg.planNo}} - {{query.plan}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text> -->
      <query-plan :planTitle="pkg.planNo + ' - ' + query.plan"></query-plan>
    </div>
    <v-card-text v-else>
      No plan selected
    </v-card-text>
  </v-card>
</template>

<script>
import QueryPlan from '../../shared/plans/QueryPlan'
export default {
  data() {
    return {
      labels: {
        planInfo: 'Plan Information',
        selectedPlan: 'Selected Plan'
      }
    }
  },
  computed: {
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    pkg() {
      return this.$store.state.agency.quotation.packageForm
    }
  },
  components: {
    QueryPlan
  }
}
</script>

<style>
</style>
